import styled from 'styled-components';

export const Flags = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: ${props => props.theme.spacing(4)};
  align-content: center;
  @media ${props => props.theme.tablet} {
    margin-bottom: ${props => props.theme.spacing(8)};
  }
`;

export const ImageContainer = styled.div`
  margin: ${props => props.theme.spacing(2, 2, 1, 1)};
`;

export const StripeText = styled.div`
  display: flex;
  align-items: center;
  ${props => props.theme.typography.label}
`;
